export class MessageEntity {
    icon;
    title;
    text;
    confirmText;
    cancelText;
    confirmAction;
    cancelAction;
    modalBody;
  
    constructor(icon = "", title = null, text = "", confirmText="", cancelText="",confirmAction=null, cancelAction=null, modalBody= null) {
      this.icon = icon;
      this.title = title;
      this.text = text;
      this.confirmText = confirmText;
      this.cancelText = cancelText;
      this.confirmAction = confirmAction;
      this.cancelAction = cancelAction;
      this.modalBody = modalBody;
    }
  }
  